import { defineMessage } from 'services/localization';

export const messages = {
    createAndConnect: defineMessage('create_and_connect'),
    createDemo: defineMessage('create_and_connect_a_qu_ine_btestb_organisation'),
    demoHeader: defineMessage('perfect_for_thorough_te__production_is_affected'),
    demoDescribe: defineMessage('check_how_approvalmax_f_kbooks_online_demo_data'),
    systemName: defineMessage('quickbooks_online'),
    connectToOrganisation: defineMessage('connect_your_quickbooks_online_organisation'),
    connectToOrgHeader: defineMessage('perfect_for_a_quick_sta__quickbooks_online_data'),
};
